export const datasourcePrefix = 'Bentley.PW--';
